import styled from 'styled-components';
import photo1 from 'assets/images/photo-1.jpg';
import { fonts } from 'styles';

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  display: flex;
  position: relative;
  background: #000 url(${photo1}) no-repeat center center;
  background-size: contain;
`;

export const Content = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding-bottom: 80px;
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 53px;
  line-height: 48px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 5px;
  color: #fff;
  margin-bottom: 32px;
`;

export const Text = styled.article`
  width: 388px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  margin-bottom: 56px;
`;

export const Credit = styled.div`
  width: 100%;
  max-width: 360px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  border-top: 1px solid #ffffff50;
  padding-top: 40px;

  span {
    font-family: ${fonts.BentonSansBold};
  }
`;

export const Legend = styled.div`
  width: 100%;
  max-width: 227px;
  position: absolute;
  right: 48px;
  bottom: 48px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 11px;
  line-height: 17px;
  color: #fff;
  text-align: right;
`;
